import { DisplayComponent } from '@/components/DisplayComponent';
import { GenericLenderCard } from '@/components/GenericLenderCard';
import { Header } from '@/components/Header';
import { MultipleUserInput } from '@/components/MultipleUserInput';
import { ProgressBar } from '@/components/ProgressBar';
import { Slogan } from '@/components/Slogan';
import { Balloon } from '@/UserInput/Balloon';
import { Deposit } from '@/UserInput/Deposit';
import { LoanAmount } from '@/UserInput/LoanAmount';
import { LoanTerm } from '@/UserInput/LoanTerm';
import { LoanUsage } from '@/UserInput/LoanUsage';
import { PurchasePrice } from '@/UserInput/PurchasePrice';

import { CampaignLandingButton } from './CampaignLandingButton';

export const testId = 'CampaignLanding';

export function CampaignLanding(): JSX.Element {
    // ***** CONSTANTS *****
    const baseId = 'screen-CampaignLanding';

    return (
        <DisplayComponent baseId={baseId} data-testid={testId}>
            <Header />
            <Slogan />
            <ProgressBar />
            <MultipleUserInput>
                <PurchasePrice
                    showErrors={false}
                    baseId={baseId}
                    title='Purchase Price'
                />
                <Balloon showErrors={false} baseId={baseId} />
            </MultipleUserInput>
            <MultipleUserInput>
                <Deposit showErrors={false} baseId={baseId} />
                <LoanAmount baseId={baseId} />
            </MultipleUserInput>
            <MultipleUserInput>
                <LoanTerm baseId={baseId} />
                <div className='h-4 w-full' />
            </MultipleUserInput>

            <LoanUsage showErrors={false} baseId={baseId} />
            <GenericLenderCard />
            <div className='h-4 w-full' />
            <CampaignLandingButton />
            <div />
        </DisplayComponent>
    );
}
